module.exports = __webpack_public_path__ + "img/radar_ok.97b205a0.svg";